document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("line-item:change:end", handleCartChange);
  document.addEventListener("cart:item-added", handleCartChange);
  let removingLonelyUpgrades = false;
  let addingPromo = false;

  async function handleCartChange(event) {
    if(document.body.dataset.promo && document.body.dataset.promo !== '') {
      await maybeAddPromo();
    }
    if (removingLonelyUpgrades) {
      return;
    }
    const cart = await getCart("/cart.js");
    removingLonelyUpgrades = true;
    removeLonelyUpgrades(cart);
  }

  async function getCart(url) {
    const cart = await fetch(url)
      .then((data) => {
        return data.json();
      })
      .then((data) => {
        return data;
      })
      .catch((err) => {
        console.log("Failed to fetch page: ", err);
      });
    return cart;
  }

  async function addToCart(variant_id, quantity) {
    if (variant_id && quantity) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variant_id,
          quantity: quantity
        })
      })
      .then((data) => {
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(() => {
        addingPromo = false;
      });
    }
  }

  async function maybeAddPromo() {
    if (addingPromo) return;
    const promoCart = await getCart("/cart?view=promos");
    if(promoCart && promoCart.variant_id) {
      addingPromo = true;
      if(promoCart.discount_code) {
        const discountApplyUrl = "/discount/" + promoCart.discount_code; 
        await fetch(discountApplyUrl);
      }
      await addToCart(promoCart.variant_id, promoCart.quantity);
    }
  }

  function removeLonelyUpgrades(cart) {
    let embroideryQty = 0;
    let coolingQty = 0;
    let customIndex = 0;

    const cooling = cart.items.filter((item) => {
      if (item.product_title.includes("Cooling")) {
        coolingQty += item.quantity;
        return item;
      }
    });

    const embroidery = cart.items.filter((item) => {
      if (item.product_title.includes("Embroidery")) {
        embroideryQty += item.quantity;
        return item;
      }
    });

    let bedQty = cart.items.reduce((total, item) => {
      if (item.product_title.includes("Bed") || item.product_title == "Barker Junior") {
        return total + item.quantity;
      }
      return total;
    }, 0);

    let coverQty = cart.items.reduce((total, item) => {
      if (item.product_title.includes("Cover")) {
        return total + item.quantity;
      }
      return total;
    }, 0);

    let lonelyUpgrades = {
      updates: {},
    };

    if (coolingQty > bedQty) {
      let coolingToRemove = coolingQty - bedQty;
      while (coolingToRemove > 0) {
        const coolingQty = cooling[customIndex].quantity;
        if (coolingQty < coolingToRemove) {
          lonelyUpgrades.updates[cooling[customIndex].id] = 0;
          coolingToRemove = coolingToRemove - coolingQty;
        } else {
          lonelyUpgrades.updates[cooling[customIndex].id] = coolingQty - coolingToRemove;
          coolingToRemove = 0;
        }
        customIndex++;
      }
    }

    const productsWithEmbroidery = bedQty + coverQty;
    if (embroideryQty > productsWithEmbroidery) {
      let embroideryToRemove = embroideryQty - productsWithEmbroidery;
      customIndex = 0;
      while (embroideryToRemove > 0) {
        const embroideryQty = embroidery[customIndex].quantity;
        if (embroideryQty < embroideryToRemove) {
          lonelyUpgrades.updates[embroidery[customIndex].id] = 0;
          embroideryToRemove = embroideryToRemove - embroideryQty;
        } else {
          lonelyUpgrades.updates[embroidery[customIndex].id] = embroideryQty - embroideryToRemove;
          embroideryToRemove = 0;
        }
        customIndex++;
      }
    }

    if (Object.keys(lonelyUpgrades.updates).length) {
      fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(lonelyUpgrades),
      }).then((data) => {
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      }).catch((err) => {
        console.log("Failed to fetch page: ", err);
      }).finally(() => {
        removingLonelyUpgrades = false;
        if (window.location.pathname === '/cart') {
          window.location.reload();
        }
      });
    } else {
      removingLonelyUpgrades = false;
    }
  }

  handleCartChange();

  function setPromoAttr() {
    let currentPromo = false;
    let promoElm = document.querySelector('#bb-promo');

    if (promoElm && promoElm.dataset.bbPromo) {
      currentPromo = promoElm.dataset.bbPromo;
    }
    
    if(!!currentPromo) {
      let formData = {
        attributes: {
          '_active_promo': `${currentPromo}`
        }
      };
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        return response.json();
      })
      .then(data => {
        document.body.dataset.promo = currentPromo;
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
  }

  setPromoAttr();
});
